// src/guides/GuidesContext.jsx
// One shared useGuides() instance for the whole authed app. useGuides reads
// the gamification config (a Firestore getDoc per hook instance), and guide
// affordances appear on many surfaces at once (a dozen Quick Action tiles,
// mission rows, the floating route help) — per-instance hooks would multiply
// reads for identical data. The provider mounts once in DashboardLayout;
// consumers get the same resolved registry. Outside the provider (or before
// it resolves) consumers see the empty loading shape, so every surface
// fails closed to "render nothing".

import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

import useGuides from './useGuides';

const EMPTY = {
  guides: [],
  tokens: {},
  ctx: null,
  loading: true,
  byId: () => null,
  byAnchor: () => []
};

const GuidesContext = createContext(EMPTY);

export function GuidesProvider({ children }) {
  const value = useGuides();
  return <GuidesContext.Provider value={value}>{children}</GuidesContext.Provider>;
}

GuidesProvider.propTypes = { children: PropTypes.node };

export function useSharedGuides() {
  return useContext(GuidesContext) || EMPTY;
}
